let gmap = '';
const myLatLng = { lat: 39.627925, lng: -0.3055000 };
const style = [
    { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
    { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
    { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ color: '#bdbdbd' }] },
    { featureType: 'poi', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'poi.park', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'road.arterial', elementType: 'labels.text.fill', stylers: [{ color: '#757575' }] },
    { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#dadada' }] },
    { featureType: 'road.highway', elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
    { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
    { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
    { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#eeeeee' }] },
    { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
    { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#9e9e9e' }] },
];
// eslint-disable-next-line no-undef
gmap = new google.maps.Map(document.getElementById('map'), {
    center: myLatLng,
    zoom: 15,
    mapTypeControl: false,
    styles: style,
});
// eslint-disable-next-line no-undef
const infowindow = new google.maps.InfoWindow({
    content: '<div class="contact-maps"><h1 class="title-maps">sesderma</h1><p class="text-maps">Avenida dels Molins, 12</p><p class="text-maps">Polígono Industrial de,</p><p class="text-maps">Carrer de la Murta,</p><p class="text-maps">46530, Valencia</p></div>',
});
const $markerImage = document.querySelector('.markerImage');
const markerImageSvg = $markerImage.innerHTML || '';
// eslint-disable-next-line no-undef
const marker = new google.maps.Marker({
    position: myLatLng,
    map: gmap,
    icon: {
        url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(markerImageSvg.replace('{{background}}'))}`,
    },
});
marker.addListener('click', () => {
    infowindow.open(gmap, marker);
});
